import { RadioPills } from '@app/components/various/Fields/RadioPills';
import { Logo, LogoType } from '@app/components/various/Logo';
import { isDefined } from '@app/utils/is';
import { Payments, Radio } from '@typings';
import React from 'react';

interface Props {
  selected: Nullable<string>;
  className?: string;
  methods: Payments.PaymentMethod[];
  onChange: (method: string) => void;
}

const PAYMENT_METHOD_ICON: Record<Payments.PaymentMethodType, Maybe<LogoType>> = {
  pay_later: null,
  paypal_wholesale: LogoType.PayPal,
  stripe_checkout: LogoType.Stripe,
  stripe_checkout_wholesale: LogoType.Stripe,
};

export const InvoicePaymentMethods = ({ selected, methods, onChange }: Props) => {
  const [firstMethod] = methods;

  const options: Radio.PillOption[] = React.useMemo(
    () =>
      methods.map(method => {
        const methodLogo = PAYMENT_METHOD_ICON[method.paymentMethodType];

        return {
          name: method.name,
          postfix: isDefined(methodLogo) && <Logo size={38} type={methodLogo} />,
          value: method.paymentMethod,
        };
      }),
    [methods],
  );

  if (!isDefined(firstMethod)) {
    return null;
  }

  return <RadioPills name="paymentMethods" options={options} onChange={onChange} value={selected ?? firstMethod.paymentMethod} />;
};
